export default "__VITE_ASSET__CwQL5H0Y__"